import React from "react";
import { useObserver } from "mobx-react-lite";
import { TextField, Grid } from "@material-ui/core";
import { AsyncButton } from "components";
import { useStore } from "./Store";
import { useFormStore } from "./FormStore";

export default () => {
  const store = useStore();
  const formStore = useFormStore();

  const handleName = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formStore.value.name = e.target.value;
    },
    [formStore]
  );

  const save = React.useCallback(async () => {
    if (await formStore.save()) {
      store.fetchAgencies();
    }
    return true;
  }, [formStore, store]);

  return useObserver(() => (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="名前"
          value={formStore.value.name || ""}
          error={!!formStore.errors.columns.name}
          helperText={formStore.errors.columns.name}
          onChange={handleName}
        />
      </Grid>

      <Grid item xs={12}>
        <AsyncButton onAwait={save}>保存</AsyncButton>
      </Grid>
    </Grid>
  ));
};
